export default "__VITE_PUBLIC_ASSET__e9316f81__"